import { API_END_POINTS } from './networks/apiEndPoints';
import api from './networks/api';

export const getSlotConfigDayLive = async (payload) => {
    try {
        const response = await api.post(API_END_POINTS.GET_LIVE_SLOT, payload);
        const data = response.data;

        if (data.errorCode === 200) {
            if (!data.responseData) {
                throw new Error('No template data returned');
            }
            return data.responseData;
        } else {
            throw new Error(data.errorMessage || 'Failed to fetch slot config day template');
        }
    } catch (error) {
        console.error('Error fetching slot config day template:', error);
        throw error;
    }
};
